export default __webpack_public_path__ + "static/surdyks-2a71e98d2365d2f581f1a24dfded519e.png";